<div class="text-center m-3">
    <h1><strong>Manage User Permissions</strong></h1>
</div>
<div class="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of users">
                <td>{{ user.name }}</td>
                <td><button class="action-btn" (click)="handleAction(user)">Action</button></td>
            </tr>
        </tbody>
    </table>
</div>